import styled from 'styled-components'

import { mainColors } from '@avantstay/backoffice-core'

export const SecondaryItem = styled.li`
  font-size: 14px;
  margin-left: 24px;
  font-weight: 400;
  color: ${mainColors.neutralExtraDark};
  list-style: none;
  display: flex;
`

export const SecondaryUl = styled.ul`
  padding-left: 0;
  a:hover li,
  a.active li {
    cursor: default;
    color: ${mainColors.accentLight};
  }

  & a li {
    margin-top: 25px;
  }

  & a:last-child li {
    margin-bottom: 30px;
  }
`

export const Bullet = styled.div`
  margin-right: 20px;
  opacity: 0.4;
  display: inline-block;
  width: 10px;
`
